var e = "_groupHead_1wxk0_1",
  o = {
    groupHead: e
  };
export { o as default, e as groupHead };